/** В режиме keycloak токен читаем пассивно: попытка обновить чужую сессию разлогинит пользователя */

import { keycloakAuthService } from '@/services/keycloakAuth';
import { isTokenExpired } from '@/utils/jwt';
import { getEnv } from '@/runtime-config';

export const SP_AUTH_STORAGE_KEY = 'AUTH';

function isKeycloakAuthMode(): boolean {
  return getEnv('AUTH_MODE') === 'keycloak';
}

export function hasSpAuthRecord(): boolean {
  try {
    return localStorage.getItem(SP_AUTH_STORAGE_KEY) !== null;
  } catch (e) {
    return false;
  }
}

function readAuthRecord(): any {
  try {
    const raw = localStorage.getItem(SP_AUTH_STORAGE_KEY);

    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

export function getSpAccessToken(): string | null {
  if (isKeycloakAuthMode()) {
    try {
      const token = keycloakAuthService.getAccessToken();

      if (!token) {
        return null;
      }

      // Просроченный токен отдаём как null: обновлением занимается штатный перехватчик SmartPricing
      return isTokenExpired(token) ? null : token;
    } catch (e) {
      return null;
    }
  }

  const parsed = readAuthRecord();
  const token = parsed && parsed.access_token ? parsed.access_token : null;

  return typeof token === 'string' && token !== '' ? token : null;
}

/** Отпечаток учётной записи нужен, чтобы выбросить мобильный токен при смене пользователя */
export function getSpSessionFingerprint(): string | null {
  if (isKeycloakAuthMode()) {
    try {
      const token = keycloakAuthService.getAccessToken();

      if (token) {
        const parts = token.split('.');

        if (parts.length === 3) {
          const payload = readJwtSubject(token);

          if (payload !== null) {
            return 'kc:' + payload;
          }
        }
      }
    } catch (e) {
    }
  }

  const parsed = readAuthRecord();

  if (!parsed) {
    return null;
  }

  const userId = parsed.user_id !== undefined && parsed.user_id !== null ? String(parsed.user_id) : '';
  const login = parsed.login !== undefined && parsed.login !== null ? String(parsed.login) : '';
  const username = parsed.username !== undefined && parsed.username !== null ? String(parsed.username) : '';
  const fingerprint = userId + '|' + login + '|' + username;

  return fingerprint === '||' ? null : fingerprint;
}

function readJwtSubject(token: string): string | null {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join(''),
    );
    const payload = JSON.parse(json);

    return payload && payload.sub ? String(payload.sub) : null;
  } catch (e) {
    return null;
  }
}
